const newActionHeader = {
  label: 'CREATE A POST'
};

export default newActionHeader;
